module.exports = __webpack_public_path__ + "static/media/my-invoice-history.00c8d988.svg";